import React from 'react'
import { Field } from 'redux-form'
import renderTextarea from '../fields/renderTextarea'
import i18n from '../../translations/i18n';

let InterpretingOptions = props => {
	let lng = props.lng;
	return (
		<div>
			<div className="row form-section">
				<div className="col-12 form-input">
					<Field
						name="specialInstructions"
						component={renderTextarea}
						label={i18n.t('interpreting.special_instructions', {lng})}
						placeholder={i18n.t('interpreting.special_instructions_placeholder', {lng})}
					/>
				</div>
				<div className="col-12 form-input check-with-tooltip">
					<label className='simple-checkbox'>
						{i18n.t('interpreting.equipment', {lng})}
						<Field
							name="equipmentNeeded"
							component="input"
							type="checkbox"
							label={i18n.t('interpreting.equipment', {lng})}
							value="equipmentNeeded"
						/>
					<span className="checkboxmark"></span>
				</label>
			</div>
			</div>
		</div>
	)
  }


  export default InterpretingOptions


// WEBPACK FOOTER //
// ./src/components/interpreting/interpreting_options.js